const APP_MAIN_HEADER_TITLE_TYPE = 'APP_MAIN_HEADER_TITLE_TYPE';
export default APP_MAIN_HEADER_TITLE_TYPE ;
